<app-message-pop></app-message-pop>
<div class="support-banner" *ngIf="activeBanner" [innerHTML]="activeBanner.message"></div>
<div class="h-100" [ngStyle]="{ 'background-color': currentProperty?.backgroundColor }">
    <ng-container>
        <img class="app-bg-image" *ngIf="currentProperty?.backgroundLogo" [src]="currentProperty?.backgroundLogo" alt="">
        <div class="row m-0 mobile-hide" *ngIf="commonService.showMenubar()">
            <div class="col-2 p-0"></div>
            <div class="col-3 p-0">
                <img class="home-logo" [src]="commonService.resource.image.outlive_chat">
            </div>
            <div class="col-5 position-relative">
                <app-menu-bar></app-menu-bar>
            </div>
            <div class="col-2"></div>
        </div>
        <app-menu-bar class="mobile-show" *ngIf="commonService.showMenubar()"></app-menu-bar>
    </ng-container>
    <div class="row m-0 h-100">
        <div class="col p-0">
            <router-outlet (activate)="changeOfRoutes()"></router-outlet>
        </div>
    </div>
    <ng-container>
        <app-chat *ngIf="commonService.showChatOption()"></app-chat>
    </ng-container>
</div>
<app-modal #appmodal></app-modal>